import React from 'react';
import './Services.css';

const Services = () => {
  return (
    <div className="container-fluid px-0">
      <div className="row g-0">
        <div className="col-12 col-md-4 border-end wow fadeInUp" data-wow-delay="0.1s">
          <div className="p-4">
            <div className="d-flex flex-column align-items-center text-center">
              <i className="fas fa-shield-alt fa-2x mb-3" style={{ color: '#DE400E' }}></i>
              <div>
                <h6 className="text-uppercase mb-2" style={{ fontSize: '0.95rem' }}>Onsite Warranty</h6>
                <p className="mb-0" style={{ fontSize: '0.85rem', color: '#999' }}>If you buy the product from that particular place</p>
              </div>
            </div>
          </div>
        </div>
        <div className="col-12 col-md-4 border-end wow fadeInUp" data-wow-delay="0.2s">
          <div className="p-4">
            <div className="d-flex flex-column align-items-center text-center">
              <i className="fas fa-truck fa-2x mb-3" style={{ color: '#DE400E' }}></i>
              <div>
                <h6 className="text-uppercase mb-2" style={{ fontSize: '0.95rem' }}>Free Shipping</h6>
                <p className="mb-0" style={{ fontSize: '0.85rem', color: '#999' }}>For New Product with in 15 KMs</p>
              </div>
            </div>
          </div>
        </div>
        <div className="col-12 col-md-4 border-end wow fadeInUp" data-wow-delay="0.3s">
          <div className="p-4">
            <div className="d-flex flex-column align-items-center text-center">
              <i className="fas fa-headset fa-2x mb-3" style={{ color: '#DE400E' }}></i>
              <div>
                <h6 className="text-uppercase mb-2" style={{ fontSize: '0.95rem' }}>Service / Support</h6>
                <p className="mb-0" style={{ fontSize: '0.85rem', color: '#999' }}>
                  Call us <a href="tel:+919865776778" style={{ color: '#DE400E' }}>+91 9865776778</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Services;